import { Alert, List, Stack, Text, Title } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { PageHeader } from "../../components/PageHeader";

export const TournamentHome = () => {
  return (
    <div className="wp-fade-in">
      <PageHeader
        title="Tournaments"
        subtitle="Create and manage competitive tournament events"
        showBreadcrumbs={false}
      />
      <Stack>
        <Text>
          The tournament feature allows anyone to create and manage Tournaments,
          from registration process to scoring and tournament Tree systems.
        </Text>
        <Text>
          While configuring their tournaments, users are able to set the
          registrations start and end date, the tournament's start and end date,
          and more configurations depending on their needs (teams minimum and
          maximum size to register, registrations rules, what kind of tournament
          it is, is it public, ...).
          <br />
          After setting these configurations, the tournament can begin.
          <br />
          First, the tournament will open registrations when the start
          registrations date is reached.
          <br />
          Registrations will stay open until the end registrations date is
          reached. At this point, the tournament will be in a registration
          closed state.
          <br />
          Then, when the start tournament date is reached, the tournament will
          begin by setting the first step as active.
          <br />
          <br />
          <Alert icon={<IconInfoCircle />} color="indigo" variant="light">
            If automation settings are set, the step will be automatically
            generated and seeded if needed.
          </Alert>
          <br />
          Tournament creators can also choose to generate and seed their steps
          themselves.
          <br />
          Tournament admins can now update game matches to set the current score
          for each team participating in the tournament.
          <br />
          When all steps groups have finished their matches, the step will be
          closed and the next step is opened.
          <br />
          <br />
          <Alert icon={<IconInfoCircle />} color="indigo" variant="light">
            By using automation rules, the Tournament creator, can set options
            to automatically generate and seed the next step with the current
            winning (or loosing) teams.
          </Alert>
        </Text>
        <Text>
          <Title order={2}>Player Registrations</Title>
          The player registrations process starts when reaching the start
          registrations date.
          <br />
          At this point, any player will be able to create his team to register
          to the Tournament.
          <br />
          If it has a valid team (depending on the tournament configurations)
          and all the team members met the registration rules, the team will be
          automatically set to either awaiting for manual validation or
          validated as participant to the tournament (depending on the
          tournament configuration).
          <br />
          <br />
          <Alert icon={<IconInfoCircle />} color="indigo" variant="light">
            The manual validation state requires a manual validation of the team
            by a Tournament admin.
          </Alert>
        </Text>
        <Text>
          <Title order={2}>Registration rules</Title>
          Registration rules are a specific configuration part that can be
          enabled to provide very flexible rules that users must meet to
          register to the tournament.
          <br />
          The requirements can range from player profile properties values set
          on a player profile to having a specific external account linked to
          their player profile.
          <br />
          For example, it is possible to create a registration rule that
          requires that the player has a League Of Legends account linked with,
          at least, a Diamond rank and/or a Twitch channel with a follower count
          of 1,000.
          <br />
          The goal here is to provide the most flexible way to easily set
          registration requirements without having to validate each teams
          manually.
        </Text>
        <Text>
          <Title order={2}>Steps</Title>
          A Step represents each steps of a tournament.
          <br />
          For example, you can create a Round robin step for your
          qualifications, then create an Elimination Tree step for your
          Playoffs.
          <br />
          Steps can be linked together using automation or can be manually
          seeded.
          <br />
          It is important to remember that each Step is independent of each
          other and only automation rules, or manual seeding will result in
          updating the Step participating teams.
          <br />
          There are currently 4 steps types available:
          <List>
            <List.Item>Round-Robin groups</List.Item>
            <List.Item>Scoring</List.Item>
            <List.Item>
              FFA Tournament Trees (Single and double elimination)
            </List.Item>
            <List.Item>Custom Custom steps</List.Item>
          </List>
          Custom steps allows you to create your own custom configuration for a
          step.
          <br />
          This means that you will be able to create your own games and matches,
          and provide automation steps to define how winning and losing teams
          are managed.
          <br />
          This is longer to create and harder to maintain, but allows you to
          completely decide how your step is executed.
        </Text>
        <Text>
          <Title order={2}>Groups</Title>
          Group defines multiple team groups that will be able to match against
          each others.
          <br />
          For example, in a Round-Robin system, it will define each pool of
          teams that will match against each others.
          <br />
          In a Tree setting, each group represent a tournament tree, for
          example, for a double elimination tree, there are two distinct groups,
          the initial tree and the loosing tree, players that loses games are
          redirected through the loosing tree.
          <br />
          Automation rules can be added to groups to define what to do if a team
          loses or win its games.
          <br />
          Groups also defines how many teams are declared winners, and if they
          need to be seeded to another group/step.
          <br />
          The same can be made with loosing teams.
        </Text>
        <Text>
          <Title order={2}>Rounds</Title>
          Each round represents an internal step for groups.
          <br />
          It is typically the next games set for a team or defines an important
          moment during the step (for example, switching to another game).
          <br />
          Typically, Rounds are used to generate the tournament tree, by
          defining where are currently the players in the Group (semi finals,
          finals, ...).
        </Text>
        <Text>
          <Title order={2}>Games</Title>
          A game is composed of multiple Matches and defines which teams are
          getting against each others.
          <br />
          The game is typically defined by the maximum number of winning matches
          needed to define a winning team.
          <br />
          When the threshold of wined matches is reached, and the number of
          winning teams required to end the game is reached, the game is set as
          ENDED and teams are transferred to other games depending on their
          winning status.
        </Text>
        <Text>
          <Title order={2}>Matches</Title>
          A match represents the result of a in-game confrontation.
          <br />
          It typically contains the current teams scores and some variables
          (either to help for score calculations, or to show on the tournament
          page, ex: kill count, golds won, ...).
          <br />A match is considered ended when all the teams that are
          participating in this match have a match status set (either winner or
          loser).
        </Text>
      </Stack>
    </div>
  );
};
